import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../assets/css/CompanySelectorModal.css";
import { useNavigate } from "react-router-dom";

const roles = [
  {
    role_id: 1,
    role_name: "Admin",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXBsb3llZV9pZCI6MzksImlhdCI6MTc1Mzc3MTk1NH0.Q-xI-yQnxRaUYkWZ75jqYzdxhsMeI7k1yksdkXeuYAY",
  },
  {
    role_id: 2,
    role_name: "HR",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXBsb3llZV9pZCI6NDAsImlhdCI6MTc1Mzc3MjAxOH0.P1x0KUvSTJ-Em8zws4uLeOFqNbG0Pnvw4lNfbdU2Ehc",
  },
  {
    role_id: 3,
    role_name: "Employee",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXBsb3llZV9pZCI6NDIsImlhdCI6MTc1Mzc3MTk5Nn0.6W1ItUb0RNg-BBF332CrUpDl1kSZB6wZIoq3QIlOxmI",
  },
];

const SwitchDemoRole = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const currentRole = localStorage.getItem("employee_role");
  const [selectedRole, setSelectedRole] = useState(null);
  const requestor_id = localStorage.getItem("requestor_id");

  const selectRole = (role) => {
    setSelectedRole(role);
    setError({});
  };

  const switchRole = async (selectedRole) => {
    if (!selectedRole.accessToken) {
      setError({ accessToken: "Access Toke not found !" });
    } else {
      setError({});
      const path = "/login/token?accessToken=";
      navigate(
        `${path}${selectedRole.accessToken}&requestor_id=${requestor_id}`
      );
    }
  };

  return (
    <Modal
      show={show}
      centered
      animation
      size="sm"
      className="company-selector-modal"
    >
      <Modal.Header>
        <Modal.Title>Select a Role</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {roles
          ?.filter((role) => role?.role_id != currentRole)
          .map((role) => (
            <div
              key={role?.role_id}
              className={`company-item ${
                selectedRole && selectedRole?.role_id === role?.role_id
                  ? "selected"
                  : ""
              }`}
              onClick={() => selectRole(role)}
            >
              <span>{role?.role_name}</span>
            </div>
          ))}

        {error?.accessToken && (
          <span className="text-danger">* {error?.accessToken}</span>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-cancel" onClick={onHide}>
          Cancel
        </Button>
        <Button
          className="btn-continue"
          onClick={() => switchRole(selectedRole)}
        >
          Switch
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SwitchDemoRole;
